import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { SwiperModule } from 'swiper/angular';
import { QRCodeModule } from 'angularx-qrcode';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpErrorInterceptor, TokenInterceptor } from './interceptors';
import { SafeUrl, ConditionalUppercasePipe } from './pipes';
import {
  CardComponent,
  ChooseRewardCardComponent,
  ConfirmModalComponent,
  ConfirmRedeemModalComponent,
  DrawingComponent,
  DrawingModalComponent,
  MenuComponent,
  OfferModalComponent,
  ChooseModalComponent,
  PinModalComponent,
  SignOutComponent,
  SliderComponent,
  StatusComponent,
  SnackbarComponent,
  PopUpComponent,
  GiftCardSuccessComponent,
  HtmlConfirmModalComponent,
  InfoModalComponent,
  SwapModalComponent
} from './components';
import {
  HomeComponent,
  NotFoundComponent,
  TemplateComponent,
  ViewAddressesComponent,
  ViewEmailComponent,
  ViewNameComponent,
  ViewNickNameComponent,
  ViewPhoneComponent,
  ViewPinComponent,
  GiftTemplateComponent,
  RedemptionTemplateComponent,
  RedemptionV2TemplateComponent,
  JoingoTemplateComponent
} from './pages';
import { InputStylesDirective } from './directives/input-styles.directive';
import { CustomErrorHandlerService } from './services';
import { CarouselComponent } from './pages/carousel/carousel.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { CmsOfferCardComponent } from './components/cms-offer-card/cms-offer-card.component';
import { CmsOfferModalComponent } from './components/cms-offer-modal/cms-offer-modal.component';
import { DecimalPipe } from '@angular/common';
import { CmsDrawingCardComponent } from './components/cms-drawing-card/cms-drawing-card.component';
import { CmsDrawingModalComponent } from './components/cms-drawing-modal/cms-drawing-modal.component';
import { CarouselItemElementDirective } from './components/carousel/carousel-item-element.directive';
import { CarouselItemDirective } from './components/carousel/carousel-item.directive';
import { CarouselListComponent } from './components/carousel/carousel-list.component';
import { JoingodrawingCardComponent } from './components/joingodrawing-card/joingodrawing-card.component';
import { BreakvalueComponent } from './components/breakvalue/breakvalue.component';
import { KeyboardModule } from './modules/keyboard/keyboard.module';
import { RedemptionV2ModalComponent } from './pages/template/components/redemption-v2-modal/redemption-v2-modal.component';
import { RedemptionV2OptionCardComponent } from './pages/template/components/redemption-v2-option-card/redemption-v2-option-card.component';

@NgModule({
  declarations: [
    AppComponent,
    SafeUrl,
    ConditionalUppercasePipe,
    ConfirmModalComponent,
    SliderComponent,
    BreakvalueComponent,
    ChooseRewardCardComponent,
    CardComponent,
    DrawingComponent,
    StatusComponent,
    SnackbarComponent,
    PopUpComponent,
    PinModalComponent,
    MenuComponent,
    SignOutComponent,
    HomeComponent,
    TemplateComponent,
    OfferModalComponent,
    ChooseModalComponent,
    ViewNameComponent,
    ViewNickNameComponent,
    ViewPhoneComponent,
    ViewPinComponent,
    ViewEmailComponent,
    ViewAddressesComponent,
    GiftTemplateComponent,
    RedemptionTemplateComponent,
    RedemptionV2TemplateComponent,
    GiftCardSuccessComponent,
    HtmlConfirmModalComponent,
    InfoModalComponent,
    NotFoundComponent,
    ConfirmRedeemModalComponent,
    DrawingModalComponent,
    InputStylesDirective,
    CarouselComponent,
    MainLayoutComponent,
    CmsOfferCardComponent,
    CmsOfferModalComponent,
    CmsDrawingCardComponent,
    CmsDrawingModalComponent,
    CarouselListComponent,
    CarouselItemDirective,
    CarouselItemElementDirective,
    JoingoTemplateComponent,
    JoingodrawingCardComponent,
    SwapModalComponent,
    RedemptionV2ModalComponent,
    RedemptionV2OptionCardComponent
  ],
  exports: [],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatTabsModule,
    MatIconModule,
    MatSnackBarModule,
    SwiperModule,
    MatProgressSpinnerModule,
    KeyboardModule,
    QRCodeModule,
    PdfViewerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: CustomErrorHandlerService },
    DecimalPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
